<template>
  <BaseButton kind="main" type="secondary" :text="text" @click="openStripeUrl">
    <template #icon>
      <ExternalIcon />
    </template>
  </BaseButton>
</template>
<script lang="ts">
import { defineComponent } from "vue";

import BaseButton from "@/components/base/BaseButton.vue";
import ExternalIcon from "@/components/icons/ExternalIcon.vue";
import * as inject from "@/components/inject";
import { openExternalUrl } from "@/utils/open-external-url";

export default defineComponent({
  components: { BaseButton, ExternalIcon },
  props: {
    text: { type: String, required: true },
    /** The organization whose Stripe customer portal to open. */
    orgId: { type: String, required: true },
  },
  setup(props) {
    const controller = inject.controller();
    const openStripeUrl = async () => {
      const { url } = await controller.organization.makeCustomerPortal(
        props.orgId
      );
      openExternalUrl(url, controller);
    };

    return {
      openStripeUrl,
    };
  },
});
</script>
